import type { TypographyVariantsOptions } from "@mui/material/styles";

export const typography = {
	fontFamily:
		'"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
	// AdaptiveX Typography Scale
	h1: { fontSize: "48px", fontWeight: 700, lineHeight: "56px" },
	h2: { fontSize: "36px", fontWeight: 700, lineHeight: "44px" },
	h3: { fontSize: "24px", fontWeight: 600, lineHeight: "32px" },
	h4: { fontSize: "20px", fontWeight: 500, lineHeight: "28px" }, // Subhead
	h5: { fontSize: "18px", fontWeight: 500, lineHeight: "28px" }, // Body Large
	h6: { fontSize: "18px", fontWeight: 400, lineHeight: "28px" }, // Body Regular
	// Legacy Material-UI variants
	body1: { fontSize: "18px", fontWeight: 400, lineHeight: "28px" },
	body2: { fontSize: "14px", fontWeight: 400, lineHeight: "22px" },
	button: { fontWeight: 500 },
	caption: { fontSize: "14px", fontWeight: 400, lineHeight: "22px" },
	subtitle1: { fontSize: "18px", fontWeight: 500, lineHeight: "28px" },
	subtitle2: { fontSize: "14px", fontWeight: 500, lineHeight: "22px" },
	overline: {
		fontSize: "14px",
		fontWeight: 500,
		letterSpacing: "0.5px",
		lineHeight: "22px",
		textTransform: "uppercase",
	},
} satisfies TypographyVariantsOptions;
